import React from 'react';
import moment from 'moment';
import { PageHeader, Tabs, Button, Statistic, Descriptions } from 'antd';
import { DownloadOutlined,PlusCircleFilled,EditFilled ,DeleteFilled} from '@ant-design/icons';
import useAxios from './../../../CustomHooks/useAxios';

const dateFormat = 'YYYY-MM-DD HH:mm:ss';
export default function Delete({item,setRefressSearch,setVisibleRemove}) {
  const {axiosi}=useAxios();
  const handleDelete= async()=>{
      console.log("[handleDelete]:item=",item)
      try {
          const kq=await axiosi.delete(`ivrplanforday/${item.id}`);
          console.log("[handleDelete]:kq=",kq) ;
          setVisibleRemove(false);
          setRefressSearch((pre)=>!pre)
      } catch (error){
          if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              console.log(error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error', error.message);
            }
            console.log(error.config);
      }
  }
  return(<>
      
      <Descriptions size="small" column={1} bordered>
          <Descriptions.Item label="Company :">{item.company_name}</Descriptions.Item>
          <Descriptions.Item label="Pbxtel :">{item.pbxtel}</Descriptions.Item>
          <Descriptions.Item label="From DateTime:">{moment(item.fromdate).format(dateFormat)}</Descriptions.Item>
          <Descriptions.Item label="To DateTime :">{moment(item.todate).format(dateFormat)}</Descriptions.Item>
          <Descriptions.Item label="From time :">{item.fromtime}</Descriptions.Item>
          <Descriptions.Item label="To time :">{item.totime}</Descriptions.Item>
          <Descriptions.Item label="Main Dial Plan">{item.maindiaplanname}</Descriptions.Item>
          
          
      </Descriptions>
      <div style={{marginTop:"0.5rem"}}>
  <label style={{marginRight:"0.2rem"}}>Are you really want to delete this ?</label>
  <Button onClick={handleDelete} ><DeleteFilled style={{ color: 'red' }} />Delete</Button>
      </div>
  </>)
}